export default __webpack_public_path__ + "static/media/cancelMenu.712adaa5.svg";